import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit'

import { setApiError } from 'src/Hooks/redux'

import { NameSpace, SliceState, SliceStatus } from '../types'
import { RootState } from '..'

import { checkTrackToCreateCampaign } from './api-actions'

export interface TracksState extends SliceState {}

const initialState: TracksState = {
  status: SliceStatus.Idle,
  error: null,
}

export const spotifyTracksProcess = createSlice({
  initialState,
  name: NameSpace.SpotifyTracks,
  reducers: {
    resetSpotifyTracksState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(checkTrackToCreateCampaign.pending, (state) => {
      state.status = SliceStatus.Loading
    })
    builder.addCase(checkTrackToCreateCampaign.rejected, (state, action) => {
      state.status = SliceStatus.Failed
      state.error = setApiError(action)
    })
    builder.addCase(checkTrackToCreateCampaign.fulfilled, (state) => {
      state.error = null
      state.status = SliceStatus.Succeeded
    })
  },
})

export const { resetSpotifyTracksState } = spotifyTracksProcess.actions

const getState = (state: RootState): TracksState => state.spotifyTracks

export const getSpotifyErrorSelector = createDraftSafeSelector(
  getState,
  ({ error }) => error?.message,
)
